import type { RequestLocalStorageKey } from ':shared/enums';

import { getRequestDetailsFromLocalStorage } from ':shared/utils/get-request-details-from-localstorage';

export const increaseRequestCount = ({ key }: { key: RequestLocalStorageKey }): number => {
    const requestDetails = getRequestDetailsFromLocalStorage(key);
    requestDetails.requestCount += 1;
    localStorage.setItem(key, JSON.stringify(requestDetails));
    return requestDetails.requestCount;
};
